import React from "react";
import { createRoot } from "react-dom/client";
import ReactGA from "react-ga4";
import App from "./App";
import "./index.css";
import { FIREBASE_CONFIG } from "shared/lib/helpers";

try {
  const firebaseConfig = JSON.parse(FIREBASE_CONFIG);

  const measurementId = firebaseConfig?.measurementId;

  ReactGA.initialize(measurementId);
} catch (error) {
  console.error("error in firebase config init", error);
}

export function logAnalyticEvent(eventObj) {
  ReactGA.event(eventObj);
}

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
